import Tutorials from './Tutorials';

export default Tutorials;
